// Scrolling agruments at the bottom of the configurator

import React from "react";
import styled from 'styled-components/macro';
import { useRef } from "react";
// import { CSSTransition } from 'react-transition-group';
import Marquee from "react-fast-marquee";
import { useResizeDetector } from 'react-resize-detector';
import { useInView } from 'react-intersection-observer';
import { usePageVisibility } from 'react-page-visibility';
import { numberWithSpaces } from '../helpers';

import mass from '../assets/mass.svg';
import check from '../assets/check.svg';
import flag_french from '../assets/flag_french.svg';
import eurocodes from '../assets/eurocodes.svg';

const OPACITY_TRANSITION = 400;
const ARGUMENT_ICON_PADDING = 10;
const ARGUMENT_HEIGHT = 68;


const ArgumentblocksStyled = styled.div`
	height: ${(ARGUMENT_HEIGHT)}px;

	.line-holder {
		display: flex;
		flex-direction: row;
		justify-content: space-evenly;
	}
	position: relative;
	.ticker-holder {
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		position: absolute;

		.argument {
			margin-left: 20px;
		}
	}


	.fade-enter {
		opacity: 0;
	}
	.fade-enter-active {
		opacity: 1;
		transition: opacity ${OPACITY_TRANSITION}ms;
	}
	.fade-enter-done {
		opacity: 1;
	}

	.fade-exit {
		opacity: 1;
	}
	.fade-exit-active {
		opacity: 0;
		transition: opacity ${OPACITY_TRANSITION}ms;
	}
	.fade-exit-done {
		opacity: 0;
	}

	.argument {
		background-position: 0px 50%;
		background-repeat: no-repeat;
		height: ${(ARGUMENT_HEIGHT)}px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		sup {
			font-size: 75%;
			line-height: 0;
			position: relative;
			vertical-align: baseline;
			top: -0.5em;
		}

		&.mass {
			background-image: url(${mass});
			padding-left: ${(ARGUMENT_ICON_PADDING+42)}px;
		}
		&.flag {
			background-image: url(${flag_french});
			padding-left: ${(ARGUMENT_ICON_PADDING+42)}px;
		}
		&.eurocodes {
			background-image: url(${eurocodes});
			padding-left: ${(ARGUMENT_ICON_PADDING+52)}px;
		}
		&.check {
			background-image: url(${check});
			padding-left: ${(ARGUMENT_ICON_PADDING+32)}px;
		}
		b {
			font-weight: 700;
		}
	}
`;

function Arguments(props) {

	const argumentblocks = [
		(props.mass>0)?<div className="argument mass">
			<div className="text">
				poids de l'abri <br/>
				<b>{numberWithSpaces(Math.floor(props.mass))} kg</b>
			</div>
		</div>:false,
		<div className="argument flag">
			<div className="text">
				fabrication <br/>
				<b>100% française</b>
			</div>
		</div>,
		(props.surface<20)?<div className="argument check">
			<div className="text">
				sans permis de <br/>construire (&lt; 20m<sup>2</sup>)
			</div>
		</div>:false,
		<div className="argument eurocodes">
			<div className="text">
				ossature renforcée <br/>
				<b>conforme eurocodes</b>
			</div>
		</div>].map((argblock,i)=>{
		return argblock?<React.Fragment key={i}>
			{argblock}
		</React.Fragment>:false
	});

	// Fade const
	//
	// const csstransition_ref = React.useRef(null)
	// const [argumentblock_id,setArgumentblockID] = useState(0);
	// const [argumentblock_visible,setArgumentblockVisible] = useState(true);
	//
	// const [interval_id,setIntervalID] = useState(0);
	// const [timeout_id,setTimeoutID] = useState(0);
	//
	// Fade functions
	// const argumentblock = argumentblocks[argumentblock_id%argumentblocks.length];
	// useEffect(()=>{
	// 	return ()=>{
	// 		clearTimeout(interval_id);
	// 		clearTimeout(timeout_id);
	// 	}
	// },[interval_id,timeout_id]);
	// useEffect(()=>{
	// 	setIntervalID(setInterval(()=>{
	// 		console.log('false');
	// 		setArgumentblockVisible(false);
	//
	// 		setTimeoutID(setTimeout(()=>{
	// 			console.log('true');
	// 			setArgumentblockVisible(true);
	// 			setArgumentblockID((v)=>(v+1));
	// 		},OPACITY_TRANSITION+50));
	//
	// 	},DISPLAY_DURATION+OPACITY_TRANSITION*2));
	// },[]);
	// <CSSTransition nodeRef={csstransition_ref} in={argumentblock_visible} timeout={OPACITY_TRANSITION} classNames="fade">
	// 	<div ref={csstransition_ref}>{argumentblock}</div>
	// </CSSTransition>

	const ref = useRef();
	const { width } = useResizeDetector({targetRef:ref});
	const argumentblocks_width = 850;
	const show_all_argumentblocks = (width > argumentblocks_width);

	const [ref_ticker, in_view] = useInView();
	const page_is_visible = usePageVisibility();

	// pauseOnHover={true}
	return (
		<ArgumentblocksStyled ref={ref} className={props.className}>
			{show_all_argumentblocks?<div className="line-holder">
				{argumentblocks}
			</div>:<div className="ticker-holder" ref={ref_ticker}>
				{page_is_visible&&<Marquee height={ARGUMENT_HEIGHT} speed={50} gradientWidth={10} delay={1} play={in_view}>
					{argumentblocks}
				</Marquee>}
			</div>}
		</ArgumentblocksStyled>
	);
}

export default Arguments;
